import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '@components/Sidebar/Sidebar';
import Header from '@components/Header/Header';
import { BREAKPOINTS } from '@utils/breakpoints';

const DashboardLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(() => window.innerWidth > BREAKPOINTS.SIDEBAR);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= BREAKPOINTS.SIDEBAR) {
                setIsSidebarOpen(false);
            } else {
                setIsSidebarOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSidebar = () => {
        setIsSidebarOpen(prev => !prev);
    };
    return (
        <div className={`${isSidebarOpen ? "sidebar-open" : "sidebar-close"} flex h-screen overflow-hidden`}>
            <Sidebar isOpen={isSidebarOpen}/>
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                {/* Top header bar */}
                <Header onToggleSidebar={toggleSidebar}/>
                {/* Page content — each page renders here */}
                <main className="flex-1 overflow-y-auto overflow-x-hidden  h-[calc(100%-79px)] bg-[var(--primary-canvas-color)] relative">
                    <Outlet />                    
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;